// FileInput.js
import React, { useEffect } from 'react';

function FileInput({ onFileChange }) {
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        onFileChange(file);
    };

    useEffect(() => {
        document.addEventListener('resetData', resetFileInput);
        return () => { document.removeEventListener('resetData', resetFileInput); };
    }, [])

    function resetFileInput() {
        document.getElementById('FileInput1').value = ''
    }

    return (
        <div style={{ fontSize: 16, lineHeight: 1, textDecoration: 'none' }}>
            <input id='FileInput1' type="file" accept=".csv" onChange={handleFileChange} onClick={(e) => { e.target.value = ''; }} onInput={(e) => { if (e.target.value) { handleFileChange(e); } }} />
        </div>
    );


}

export default FileInput;